module.exports = __webpack_public_path__ + "audio/twoAudio.56f397aa.mp3";